import { TabControlAPI, TabWithContentAPI } from '@philips-emr/tws-components';
import { HistoryService, HttpService } from '@philips-emr/tws-core/lib/services';

import { Endpoint } from '../constants';

export class ShouldRenderTabsService {

  public static shouldRenderTab(api: TabWithContentAPI, shouldRenderTab: string): void {
    const { nrSeqUser, nrSeqTypeAccreditation } = HistoryService.getCurrentRouteParams();
    void HttpService.get<any>(Endpoint.GET.TYPE_OF_PROVIDER_ACCREDITATION, { nrSeqUser, nrSeqTypeAccreditation }).then(response => {
      const shouldRender = response.body[shouldRenderTab];
      if (shouldRender === 'S') {
        api.setVisible(true);
      }
    });
  }

  public static chooseDefaultTab(tabControlAPI: TabControlAPI, tabs: string[]): void {
    const { nrSeqUser, nrSeqTypeAccreditation } = HistoryService.getCurrentRouteParams();
    let found = false;
    tabs.forEach(tab => {
      if (!found) {
        void HttpService.get<any>(Endpoint.GET.TYPE_OF_PROVIDER_ACCREDITATION, { nrSeqUser, nrSeqTypeAccreditation }).then(response => {
          const shouldRender = response.body[tab];
          if (shouldRender === 'S' && !found) {
            found = true;
            tabControlAPI.setDefaultTab(tab);
            tabControlAPI.setActiveTab(tab);

          }

        });
      }
    });
  }

}
